<template>
  <div style="height: calc(100% - 80px); overflow-y: auto">
    <v-dialog v-model="swatchOpen" max-width="500px">
      <v-card>
        <v-card-title>
          Select a route colour
        </v-card-title>
        <v-card-text>
          <swatches @input="handleSwatchInput" class="clearSwatch"
                    inline></swatches>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click.stop="swatchOpen=false;">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-data-table hide-default-footer dense
                    :items-per-page="-1"
                    :items="routes"
                    :headers="[{text: 'Score', value: 'value'},{text: 'Colour', value: 'colour'}]">
        <template v-slot:item="{item}">
          <tr style="cursor: pointer"
              :class="selected.idnr === item.idnr ? 'selected-route' : ''"
              @mouseover.capture="$emit('mouseover', item)"
              @mouseout.capture="$emit('mouseout', item)"
              @click.capture="$emit('selected', item)">
            <td>
              <v-text-field dense outlined hide-details
                            style="background: white !important;"
                            v-model="item.value"></v-text-field>
            </td>
            <td>
              <v-btn dark depressed id="routeColourBtn"
                     @click.stop="swatchOpen = true"
                     :style="{backgroundColor: item.colour}">
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
  </div>
</template>

<script>
import Swatches from 'vue-swatches'
import {mapGetters} from "vuex";

export default {
  name: "RouteList",

  components: {
    Swatches
  },

  computed: {
    ...mapGetters({
      routes: 'getRoutes'
    }),
  },
  data () {
    return {
      swatchOpen: false
    }
  },
  methods: {
    handleSwatchInput(data) {
      console.dir(data)
      this.swatchOpen = false
      this.$emit('route-update', {colour: data})
    },
  },
  props: {
    height: {
      type: Number,
      default: 400
    },
    selected: {
      type: Object,
      default () {
        return {
          idnr: null
        }
      }
    }
  }
}
</script>

<style scoped>
.selected-route {
  background: rgba(0,0,0,0.2);
}
</style>
